// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"786":"f9c40aa2","977":"6a2e55a8"}[chunkId] + ".chunk.css";
};